import { render, staticRenderFns } from "./fare-list.vue?vue&type=template&id=2167c37b&"
import script from "./fare-list.vue?vue&type=script&lang=js&"
export * from "./fare-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports